import * as React from "react";

interface ExternalLinkProps extends React.HTMLProps<HTMLElement> {
    href: string;
    showIcon?: boolean;
    openInSelf?: boolean;
    onClick?: () => void;
}

const ExternalLink: React.SFC<ExternalLinkProps> = (props: ExternalLinkProps) => {
    const formatUrl = (href: string) => {
        if (href.startsWith("http")) {
            return href;
        }

        return "https://g.octopushq.com/" + href;
    };
    const onClick = (e: any) => {
        if (props.onClick) {
            props.onClick();
        }
        e.stopPropagation();
    };

    return <a href={formatUrl(props.href)} target={props.openInSelf ? "_self" : "_blank"} onClick={onClick}>{props.children}
        {props.showIcon && <em style={{marginLeft: "0.250rem"}} className="fa fa-external-link" aria-hidden="true" />}</a>;
};

ExternalLink.defaultProps = {
    showIcon: true,
    openInSelf: false
};

export default ExternalLink;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./app/components/Navigation/ExternalLink/ExternalLink.tsx